import React, { SyntheticEvent } from 'react'
import { ApolloClient } from 'apollo-client'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'

import { Store, getUserLoggedIn, UserData } from '../../reducers/index'
import { hideLoginForm, showLoginForm } from '../../actions/ui_actions'
import { Action } from '../../actions/types'
import CloseButton from '../Shared/CloseButton'
import { loginComplete } from '../../actions/user'
import { NormalizedCache } from 'apollo-cache-inmemory'
import { LoginContainer } from './Common'
import { parseToken } from '../../util/parseToken'
import { withRouter, RouteComponentProps } from 'react-router'
import { recordEvent } from '../../analytics'

type LoginFormContext = {
  client: ApolloClient<NormalizedCache>
}

type LoginProps = {
  loggedIn: boolean
  hide: () => Action
  complete: (userData: UserData) => Action
  showSignup: () => Action
  email: string | undefined
} & RouteComponentProps<{}>

type State = {
  username: string
  password: string
  error: string | null
  busy: boolean
}

type Response = {
  authenticate: {
    error: string
    ok: boolean
    token: string
  }
}

const PasswordResetUrl =
  'https://www.peikkodesigner.com/Account/Manage/ChangePassword'

class LoginForm extends React.Component<LoginProps, State> {
  static contextTypes = {
    client: () => null
  }

  context: LoginFormContext

  constructor(props: LoginProps) {
    super(props)
    this.state = {
      busy: false,
      username: props.email || '',
      password: '',
      error: null
    }
  }

  componentWillMount() {
    if (this.props.email) {
      this.setState({ username: this.props.email })
    }
  }

  tryLogin = (e: SyntheticEvent<HTMLFormElement>) => {
    const { username, password } = this.state

    this.setState({ busy: true })

    this.context.client
      .mutate<Response>({
        mutation: gql`
          mutation Authenticate($username: String!, $password: String!) {
            authenticate(username: $username, password: $password) {
              ok
              token
              error
            }
          }
        `,
        variables: { username, password }
      })
      .then(({ data }) => {
        if (!data) {
          throw new Error('No data')
        }

        const res = data.authenticate

        if (res.ok) {
          this.setState({ busy: false, error: null })

          const userData = parseToken(res.token)
          if (userData) {
            window.localStorage.setItem('peikko-dbs-token', res.token)
            recordEvent('user', 'login-complete')
            this.props.complete(userData)
          } else {
            this.setState({
              busy: false,
              error: 'Invalid authentication token'
            })
          }
        } else {
          console.warn('Login failed', res.error)
          this.setState({ busy: false, error: 'Authentication failed' })
        }
      })
      .catch(err => {
        console.warn('Login failed', err)
        this.setState({ busy: false, error: 'Authentication failed' })
      })
    e.preventDefault()
  }

  setUsername = evt => this.setState({ username: evt.currentTarget.value })
  setPassword = evt => this.setState({ password: evt.currentTarget.value })

  hide = () => {
    if (this.props.location.pathname === '/login') {
      this.props.history.push('/')
    } else {
      this.props.hide()
    }
  }

  render() {
    const { loggedIn } = this.props
    if (loggedIn) {
      return null
    }

    const { username, password, busy } = this.state

    const ok = username !== '' && password !== ''
    return (
      <LoginContainer>
        <div className="modal-inner">
          <h4>
            Log in
            <div className="spacer" />
            <CloseButton
              white={true}
              style={{ float: 'right' }}
              data-test-id="close-login"
              onClick={this.hide}
            >
              x
            </CloseButton>
          </h4>
          <div className="content">
            <h2>Welcome to Peikko Designer&reg; DELTABEAM SELECT</h2>
            <p>
              Get started to optimize and select suitable DELTABEAM&reg; for
              your design.
            </p>
            <form onSubmit={this.tryLogin}>
              {this.state.error && <p>{this.state.error}</p>}

              <input
                name="username"
                onChange={this.setUsername}
                value={username}
                type="text"
                autoFocus={true}
                placeholder="Username (email)"
              />

              <input
                onChange={this.setPassword}
                value={password}
                name="password"
                type="password"
                placeholder="Password"
              />
              <div className="extras">
                <div className="spacer" />
                <a href={PasswordResetUrl} target="_blank">
                  Forgot your password?
                </a>
              </div>
              <input
                type="submit"
                name="submit"
                value="Log in"
                disabled={!ok || busy}
              />
            </form>
            <div className="bottom-container">
              <h3>Don't have an account? </h3>
              <h3>
                Please create account{' '}
                <a
                  href="https://peikkodesigner.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>{' '}
              </h3>
            </div>
          </div>
        </div>
        {busy && <div className="spinner" />}
      </LoginContainer>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  loggedIn: getUserLoggedIn(state),
  email: state.ui.email
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  hide: () => dispatch(hideLoginForm()),
  complete: (userData: UserData) => dispatch(loginComplete(userData)),
  showSignup: () => dispatch(showLoginForm('signup'))
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginForm)
)



// WEBPACK FOOTER //
// ./src/Components/LoginForm/Login.tsx